__turbopack_context__.v({
  "avatar": "CandidateCardMultiCorporate-module__818pDa__avatar",
  "avatarBlurred": "CandidateCardMultiCorporate-module__818pDa__avatarBlurred",
  "avatarFallback": "CandidateCardMultiCorporate-module__818pDa__avatarFallback",
  "avatarGrid": "CandidateCardMultiCorporate-module__818pDa__avatarGrid",
  "avatarImage": "CandidateCardMultiCorporate-module__818pDa__avatarImage",
  "avatarMore": "CandidateCardMultiCorporate-module__818pDa__avatarMore",
  "avatarPanel": "CandidateCardMultiCorporate-module__818pDa__avatarPanel",
  "bottom": "CandidateCardMultiCorporate-module__818pDa__bottom",
  "card": "CandidateCardMultiCorporate-module__818pDa__card",
  "cta": "CandidateCardMultiCorporate-module__818pDa__cta",
  "ctaIcon": "CandidateCardMultiCorporate-module__818pDa__ctaIcon",
  "headings": "CandidateCardMultiCorporate-module__818pDa__headings",
  "headingsText": "CandidateCardMultiCorporate-module__818pDa__headingsText",
  "meta": "CandidateCardMultiCorporate-module__818pDa__meta",
  "metaSeparator": "CandidateCardMultiCorporate-module__818pDa__metaSeparator",
  "moreSkills": "CandidateCardMultiCorporate-module__818pDa__moreSkills",
  "recruiterLogo": "CandidateCardMultiCorporate-module__818pDa__recruiterLogo",
  "recruiterLogoPlaceholder": "CandidateCardMultiCorporate-module__818pDa__recruiterLogoPlaceholder",
  "root": "CandidateCardMultiCorporate-module__818pDa__root",
  "skill": "CandidateCardMultiCorporate-module__818pDa__skill",
  "skillEmoji": "CandidateCardMultiCorporate-module__818pDa__skillEmoji",
  "skillLogo": "CandidateCardMultiCorporate-module__818pDa__skillLogo",
  "skillsList": "CandidateCardMultiCorporate-module__818pDa__skillsList",
  "skillsPanel": "CandidateCardMultiCorporate-module__818pDa__skillsPanel",
  "title": "CandidateCardMultiCorporate-module__818pDa__title",
  "top": "CandidateCardMultiCorporate-module__818pDa__top",
});
